<template>
  <div>
    <!--提示语-->
    <div style="padding: 10px;color: #d9d9d9">{{ $t('CargoMsg.Cargo_OcrTip') }}</div>
    <div class="result-form-se">
      <div :style="{cursor:'pointer',width: showBookRecognitionResults ? '100%': '50%'}">
        <!--ocr识别字段-header-->
        <div class="row" style="position: relative;">
          <div class="item1" style="font-weight: bold;color: white;background-color: #3f3f3f">
            <span>{{ $t('CargoMsg.Cargo_FieldName') }}</span>
          </div>
          <div v-if="showBookRecognitionResults" class="item2" style="font-weight: bold;color: white;background-color: #3f3f3f">{{ $t('CargoMsg.Cargo_BillResults') }}</div>
          <div class="item3" style="font-weight: bold;color: white;background-color: #abd08e">{{ $t('CargoMsg.Cargo_BillResults2') }}</div>
        </div>
        <!--ocr识别字段-content-->
        <div v-if="currentOcrRecognitionFields && currentOcrRecognitionFields.length > 0">
          <div v-for="item in currentOcrRecognitionFields" :key="item.code">
            <div style="display: none">{{ getValueBorderColor(item) }}</div>
            <!--MBL-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_BILL_NO.code)" class="row" @click="handleFocus(item.code)">
              <div v-if="source === INTELLIGENT_DOCUMENT_SOURCE_5.code || source === INTELLIGENT_DOCUMENT_SOURCE_6.code" class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_BLNo') }} </div>
              <div v-if="[INTELLIGENT_DOCUMENT_SOURCE_7.code, INTELLIGENT_DOCUMENT_SOURCE_16.code, INTELLIGENT_DOCUMENT_SOURCE_8.code].includes(source)" class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_SeparateNumber') }} </div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.billNo" class="item3" :class="{ 'input-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--提单形式-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_ORDER_TYPE.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.BLForm') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">
                {{ resultJson[item.code] }}
              </div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-select
                v-model="doc.orderType"
                class="item3"
                :class="{ 'input-red': item.redColor }"
                :placeholder="''"
                :disabled="fieldEditCheck(item.code)"
                no="orderType"
                clearable
                @clear="clear(item)"
              >
                <el-option
                  v-for="(item,index) in blModeList"
                  :key="index"
                  :label="item.name"
                  :value="item.serialNumber"
                />
              </el-select>
            </div>
            <!--正本份数-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_BL_NUMBER.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_NumberOfOriginalCopies') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.blNumber" class="item3" :class="{ 'input-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--发货人-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_SHIPPER.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Message.Shipper') }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" :class="{ 'textarea-red': item.redColor }" />
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.shipper" :rows="6" type="textarea" class="item3" :class="{ 'textarea-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--收货人-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_CONSIGNEE.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Message.Consignee') }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" :class="{ 'textarea-red': item.redColor }" />
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.consignee" :rows="6" type="textarea" class="item3" :class="{ 'textarea-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--通知人-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_NOTIFY.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Message.Notify') }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" :class="{ 'textarea-red': item.redColor }" />
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.notify" :rows="6" type="textarea" class="item3" :class="{ 'textarea-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--船公司-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_CARRIER.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.ShippingCompany') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <cargo-company-select
                class="item3"
                :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                :default-value="doc.carrierId||''"
                :placeholder="''"
                :class="{ 'input-red': item.redColor }"
                :disabled="fieldEditCheck(item.code)"
                @clear="clear(item)"
                @change="p=>{pm.carrierChangeHandler(doc.dischargingPortCode, p.value)} "
              />
            </div>
            <!--船名-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_VESSEL.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.vessel') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <cargo-advance-select
                no="vessel"
                class="item3"
                :select-type="selectTypeNames.static_data_Vessel"
                :cache="false"
                filterable
                :allow-create="true"
                :default-value="doc.vessel"
                :static-options="vesselList"
                :class="{ 'input-red': item.redColor }"
                :disabled="fieldEditCheck(item.code)"
                @parentCallBack="p=>{onVesselSelectionChange(p)}"
              />
            </div>
            <!--航次-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_VOYAGE.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.voyage') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <div style="display: flex;justify-content: space-between" class="item3">
                <el-input v-model="doc.voyageFlight" class="item3" :class="{ 'input-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
              </div>
            </div>
            <!--运费条款-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_PAYMENT_TERM.code)" class="row" @click="handleFocus(item.code)">
              <div style="display: block; width:100%">
                <div style="display: flex">
                  <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.FreightTerm') }}</div>
                  <div v-if="showBookRecognitionResults" class="item2 itemAssign" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
                  <div class="itemAssign">
                    <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
                  </div>
                  <cargo-advance-select
                    class="item3"
                    :class="{ 'input-red': item.redColor }"
                    :select-type="selectTypeNames.basic_data_PaymentTerm"
                    filterable
                    clearable
                    :default-value="doc.paymentTermMBL"
                    :disabled="fieldEditCheck(item.code)"
                    @clear="clear(item)"
                    @parentCallBack="p=>{
                      paymentTermMBL = p.value;
                      doc.paymentTermMBL=p.value;
                    }"
                  />
                </div>
                <!--付款方-->
                <div v-show="paymentTermMBL === '3P' && source === INTELLIGENT_DOCUMENT_SOURCE_5.code" style="display: flex">
                  <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_Payment1') }}</div>
                  <el-input v-if="showBookRecognitionResults" value="" disabled :rows="6" type="textarea" class="item2" :class="{ 'textarea-red': item.redColor }" />
                  <div class="itemAssign">
                    <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
                  </div>
                  <el-input v-model="doc.paymentData" :rows="6" type="textarea" class="item3" :class="{ 'textarea-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
                </div>
              </div>
            </div>
            <!--运输条款-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_FREIGHT_TERM.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_TransitTerm') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <cargo-advance-select
                no="freightTerm"
                class="item3"
                :class="{ 'input-red': item.redColor }"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                filterable
                :disabled="fieldEditCheck(item.code)"
                :clearable="false"
                :default-value="doc.freightTerm || ''"
                @clear="clear(item)"
                @parentCallBack="p=>{doc.freightTerm=p.value}"
              />
            </div>
            <!--箱型箱量-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_CONTAINER_INFOS.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">
                <div style="display: block">
                  <div>{{ $t('CargoMsg.Cargo_CartonQuantity') }}</div>
                  <div style="color:#cbc7c7;">{{ '(' + $t('CargoMsg.Cargo_NotUpdate') + ')' }}</div>
                </div>
              </div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="item3" :class="{ 'input-red': item.redColor }" style="overflow-y: auto;">
                <div style="display: flex">
                  <div style="display: flex;flex-direction: column;max-height: 200px;">
                    <div v-for="(item,index) in doc.seaEQ" :key="index">
                      <div style="display: flex">
                        <div style="width: 49%">
                          <el-input-number v-model="item.eqQuantity" :disabled="true" :controls="false" class="item3-1" no="eqQuantity" style="width: 40px;" />
                          <span style="margin-left:5px">X</span>
                        </div>
                        <div style="display:flex;">
                          <cargo-advance-select
                            class="item3-1"
                            no="eqSize"
                            :select-type="selectTypeNames.local_cache_EQSize"
                            :fields="['code']"
                            filterable
                            :placeholder="' '"
                            :show-copy="false"
                            :disabled="true"
                            :default-value="item.eqSize"
                            style="width: 60px;margin-left:5px"
                            tag-name="code"
                            @parentCallBack="p=>{changeSizeCallBack(item, p)}"
                          />
                          <cargo-advance-select
                            class="item3-1"
                            no="eqType"
                            :select-type="selectTypeNames.basic_data_EQType"
                            :fields="['code']"
                            filterable
                            :placeholder="' '"
                            :show-copy="false"
                            :disabled="true"
                            :default-value="item.eqType"
                            style="width: 60px;margin-left:5px"
                            tag-name="code"
                            @parentCallBack="p=>{changeTypeCallBack(item, p)}"
                          />
                        </div>
                        <!--                        <div style="color: #1398f1; margin-left:5px;font-size:25px;cursor:pointer" @click="addSeaEQ">+</div>-->
                        <!--                        <div style="color: #1398f1; margin-left:5px;font-size:25px;cursor:pointer" @click="deleteSeaEQ(index)">-</div>-->
                      </div>
                    </div>
                  </div>
                  <!--                  <div v-if="!doc.seaEQ || doc.seaEQ.length === 0" style="color: #1398f1; margin-top: 10px;margin-left:5px;cursor:pointer" @click="addSeaEQ">{{ $t('CargoMsg.Cargo_Add') }}</div>-->
                </div>
              </div>
            </div>
            <!--付款地点-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_PAYMENT_PLACE_BL.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PlaceOfPayment') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.paymentPlaceBL" class="item3" :class="{ 'input-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--签发地点-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_TD_SIGN_PLACE_BL.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PlaceOfIssue') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.signPlaceBL" class="item3" :class="{ 'input-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--签发日期-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_TD_SIGN_DATE_BL.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.DateOfIssue') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-date-picker
                class="item3"
                :class="{ 'input-red': item.redColor }"
                :value="doc.signDateBL"
                type="date"
                value-format="yyyy-MM-dd"
                :disabled="fieldEditCheck(item.code)"
                @input="signDateBLChange"
              />
            </div>
            <!--HS编号-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_HS_CODE.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.HsCode') }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" :class="{ 'textarea-red': item.redColor }" />
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.hsCode" :rows="6" type="textarea" class="item3" :class="{ 'textarea-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--发货地-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_DISPATCHING_PLACE.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PlaceOfReceiptOnBl') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.dispatchingPlace" class="item3" :class="{ 'input-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--起运港-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_LOADING_PORT.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PortOfLoadingOnBl') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.loadingPort" class="item3" :class="{ 'input-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--卸货港-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_DISCHARGING_PORT.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PortOfDischargeOnBl') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.dischargingPort" class="item3" :class="{ 'input-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--卸货港-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_DESTINATION_PORT.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PlaceOfDeliveryOnBl') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.destinationPort" class="item3" :class="{ 'input-red': item.redColor }" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--件数-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_TD_QUANTITY.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Quantity') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input-number v-model="doc.quantity" :controls="false" class="item3" :class="{ 'input-red': item.redColor }" no="quantityContract" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--包装-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_PACKING.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Package') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <cargo-packing-select
                no="packing"
                class="item3"
                :default-value="doc.packing"
                :placeholder="''"
                :class="{ 'input-red': item.redColor }"
                :disabled="fieldEditCheck(item.code)"
                @clear="clear(item)"
                @change="p=>{doc.packing=p.value;}"
              />
            </div>
            <!--小件件数-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_INSIDE_QUANTITY.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Pieces2') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input-number v-model="doc.insideQuantity" :controls="false" class="item3" :class="{ 'input-red': item.redColor }" no="insideQuantity" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--小件包装-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_INSIDE_PACKING.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PiecesType2') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <cargo-packing-select
                no="packing"
                class="item3"
                :default-value="doc.insidePacking"
                :placeholder="''"
                :class="{ 'color-red': item.redColor }"
                :disabled="fieldEditCheck(item.code)"
                @clear="clear(item)"
                @change="p=>{doc.insidePacking=p.value;}"
              />
            </div>
            <!--毛重-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_TD_WEIGHT.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Weight') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input-number v-model="doc.weight" :controls="false" class="item3" :class="{ 'input-red': item.redColor }" no="weight" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--体积-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_TD_CUBAGE.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Cubage') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :style="item.redColor ? 'color:red' :''">{{ resultJson[item.code] }}</div>
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input-number v-model="doc.cubage" :controls="false" class="item3" :class="{ 'input-red': item.redColor }" no="cubage" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--唛头-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_MARK.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Marks') }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" :class="{ 'textarea-red': item.redColor }" />
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.mark" :rows="6" type="textarea" class="item3" :class="{ 'textarea-red': item.redColor }" no="mark" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--品名-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_GOOD_NAME.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Pricing.Goods') }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" :class="{ 'textarea-red': item.redColor }" />
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.cargoEnglishName" :rows="6" type="textarea" :class="{ 'textarea-red': item.redColor }" class="item3" no="cargoEnglishName" :disabled="fieldEditCheck(item.code)" />
            </div>
            <!--备注-->
            <div v-if="showFieldItem(item, SystemConstants.OCR_FIELD_REMARKS.code)" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.remarks') }}</div>
              <el-input v-if="showBookRecognitionResults" v-model="resultJson[item.code]" disabled :rows="6" type="textarea" class="item2" :class="{ 'textarea-red': item.redColor }" />
              <div class="itemAssign">
                <span v-show="item.redColor" class="itemAssign2" @click="itemAssignClick(item)"> >> </span>
              </div>
              <el-input v-model="doc.remarks" class="item3" :rows="6" type="textarea" :class="{ 'textarea-red': item.redColor }" no="remarks" :disabled="fieldEditCheck(item.code)" />
            </div>
            <div v-if="item.code === SystemConstants.OCR_FIELD_CONTAINER_DATA.code" class="row" @click="handleFocus(item.code)">
              <div style="display: block; width: 100%; position: relative;">
                <span style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5">{{ '.' }}</span>
                <div style="padding: 10px">   {{ $t('CargoMsg.Cargo_ContainerIdTip') }}</div>
                <table class="table">
                  <!-- 表格行和单元格 -->
                  <thead>
                    <tr class="gray-row" style="height: 30px">
                      <td class="centered-cell" />
                      <td class="centered-cell">{{ $t('SeaExport.ChargeSource') }}</td>
                      <td class="centered-cell">{{ $t('SeaExport.ContainerNo') }}</td>
                      <td class="centered-cell">{{ $t('SeaExport.BoxType') }}</td>
                      <td class="centered-cell">{{ $t('SeaExport.SealNo') }}</td>
                      <td class="centered-cell">{{ $t('SeaExport.itemCount') }}</td>
                      <td class="centered-cell">{{ $t('SeaExport.Package') }}</td>
                      <td class="centered-cell">{{ $t('SeaExport.Weight2') }}</td>
                      <td class="centered-cell">{{ $t('SeaExport.Cubage') }}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in doc.container" :key="index">
                      <td v-show="item.showCheck > 0" class="centered-cell" style="width: 5%;" :rowspan="Number(item.showCheck)">
                        <input v-model="item.checked" type="checkbox">
                      </td>

                      <td class="centered-cell" style="width: 10%;">{{ item.chargeSource ? $t('CargoMsg.Cargo_RecognitionData') : $t('CargoMsg.Cargo_SystemData') }}</td>
                      <td class="centered-cell" style="width: 15%;"><el-input v-model="item.containerNo" :disabled="fieldEditCheck('container_containerNo')" no="containerNo" style="width: 100%;" @change="containerNoChargeHandler" /></td>
                      <td class="centered-cell" style="width: 10%;">{{ item.eqSizeStr }}</td>
                      <td class="centered-cell" style="width: 15%;"><el-input v-model="item.sealNo" :disabled="fieldEditCheck('container_sealNo')" no="sealNo" style="width: 100%;" /></td>
                      <td class="centered-cell" style="width: 10%;">
                        <auto-number-input
                          v-model="item.quantity"
                          no="quantity"
                          :disabled="fieldEditCheck('container_quantity')"
                          style="width: 100%;"
                          :precision="0"
                          :min="0"
                        />
                      </td>
                      <td class="centered-cell" style="width: 15%;">
                        <cargo-advance-select
                          no="packing"
                          :select-type="TYPE_NAMES.basic_data_Packing"
                          filterable
                          :disabled="fieldEditCheck('container_packing')"
                          style="width: 100%;"
                          :default-value="item.packing"
                          @parentCallBack="p=>{item.packing=p.value}"
                        />
                      </td>
                      <td class="centered-cell" style="width: 10%;">
                        <auto-number-input
                          v-model="item.weight"
                          no="weight"
                          :disabled="fieldEditCheck('container_weight')"
                          style="width: 100%;"
                          :precision="3"
                          :min="0"
                        />
                      </td>
                      <td class="centered-cell" style="width: 10%;">
                        <auto-number-input
                          v-model="item.cubage"
                          no="cubage"
                          :disabled="fieldEditCheck('container_cubage')"
                          style="width: 100%;"
                          :precision="3"
                          :min="0"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div style="padding-top: 10px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--字段校验弹窗-->
    <el-dialog
      no="fieldValidDialog"
      :visible.sync="fieldValidDialog.visible"
      :title="$t('Message.WarmReminder')"
      width="630px"
      append-to-body
    >
      <div v-for="(fieldValidResultByBook,index) in fieldValidDialog.fieldValidResults" :key="index">
        <div>{{ $t('CargoMsg.Cargo_Book') + (fieldValidResultByBook.index + 1) }}</div>
        <el-table
          :data="fieldValidResultByBook.data"
          style="width: 100%"
        >
          <el-table-column
            prop="fieldName"
            :label="$t('CargoMsg.Cargo_FieldName')"
            width="180"
          />
          <el-table-column
            prop="exceptionReason"
            :label="$t('CargoMsg.Cargo_ErrorCause')"
            width="400"
          />
        </el-table>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="fieldValidDialog.visible = false">{{ $t('Message.GotIt') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { CONTAINERLOAD_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'
import CargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import ColumnUtils from '@/utils/ColumnUtils'
import { getOcrList } from '@/api/ocrSet'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import { deepClone, getUuid } from '@/utils'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import {
  INTELLIGENT_DOCUMENT_SOURCE_5,
  INTELLIGENT_DOCUMENT_SOURCE_7,
  INTELLIGENT_DOCUMENT_SOURCE_16,
  OCR_FIELD_CARRIER,
  OCR_FIELD_IF_REQUIRED_SAVE_JOB,
  OCR_FIELD_MAP,
  OCR_FIELD_ORDER_TYPE,
  OCR_FIELD_PAYMENT_TERM,
  OCR_FIELD_FREIGHT_TERM,
  OCR_FIELD_PACKING,
  SENDING_2,
  OCR_FIELD_TD_WEIGHT,
  OCR_FIELD_CONTAINER_INFOS,
  UPLOAD_STATUS_COMPLETE_ORDER,
  MBL,
  HBL,
  OCR_FIELD_TD_CUBAGE,
  UPLOAD_STATUS_PARSE_DONE,
  OCR_FIELD_VESSEL,
  OCR_FIELD_VOYAGE,
  OCR_FIELD_ETD,
  OCR_FIELD_SHIPPER,
  OCR_FIELD_CONSIGNEE,
  OCR_FIELD_NOTIFY,
  OCR_FIELD_BILL_NO,
  INTELLIGENT_DOCUMENT_SOURCE_8,
  INTELLIGENT_DOCUMENT_SOURCE_6
} from '@/class/cargo/model/parameters/SystemConstants'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import { CONVERSION_HC } from '@/class/cargo/model/parameters/EqType'
import { loadSpecificBasicInfo } from '@/api/cache'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'
import { TabBookingFCLPM } from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCLPM'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { queryJobDataFunc } from '@/api/seaExport/intelligentBooking'
import { getSingleOnlineSettingList } from '@/api/sysManage/baseConfig/singleOnlineSetting'
import { FCL, LCL } from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'

export default {
  name: 'ResultFormSeTd',
  components: {
    CargoRichTextarea, AutoNumberInput, CargoUserSelect, CargoAdvanceSelect,
    CargoPackingSelect, cargoCompanySelect, cargoOfficeSelect, cargoDepartmentSelect },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    index: { type: Number, default: 0 },
    showAll: { type: Boolean, default: true },
    resultArray: { type: Array, default: () => [] },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      context: new BookingWorkspaceContext(),
      pm: new TabBookingFCLPM(this),
      CargoSource,
      JobUtils,
      resultJson: {},
      containerLoadTypes: CONTAINERLOAD_TYPES,
      SystemConstants,
      ColumnUtils,
      INTELLIGENT_DOCUMENT_SOURCE_5,
      INTELLIGENT_DOCUMENT_SOURCE_7,
      INTELLIGENT_DOCUMENT_SOURCE_6,
      INTELLIGENT_DOCUMENT_SOURCE_8,
      INTELLIGENT_DOCUMENT_SOURCE_16,
      selectTypeNames: TYPE_NAMES,
      useCase: 0, // 0 海运出口 1 空运出口
      expressList: [],
      mapperTexts: [],
      port: new Map(), // 提单没有映射值，托书映射代码先保留
      carrier: new Map(),
      orderType: new Map(),
      loadType: new Map(),
      shippingTerm: new Map(),
      paymentTerm: new Map(),
      incoTerm: new Map(),
      eq: new Map(),
      customer: new Map(),
      packing: new Map(),
      onlineMap: {}, // 在线对单
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      otherCheckField: [OCR_FIELD_ORDER_TYPE.code, OCR_FIELD_CARRIER.code, OCR_FIELD_CONTAINER_INFOS.code,
        OCR_FIELD_PAYMENT_TERM.code, OCR_FIELD_PACKING.code, OCR_FIELD_TD_WEIGHT.code, OCR_FIELD_TD_CUBAGE.code, OCR_FIELD_FREIGHT_TERM.code],
      colorStyle: 'red',
      doc: {
        billNo: '',
        mblNo: '',
        hblNo: '',
        orderType: '',
        blNumber: '',
        shipper: '',
        consignee: '',
        notify: '',
        paymentData: '',
        paymentPlaceBL: '',
        signPlaceBL: '',
        signDateBL: null,
        hsCode: '',
        dispatchingPlace: '',
        loadingPort: '',
        dischargingPort: '',
        destinationPort: '',
        quantity: 0,
        packing: '',
        insideQuantity: 0,
        insidePacking: '',
        weight: 0,
        cubage: 0,
        mark: '',
        cargoEnglishName: '',
        remarks: '',

        carrierId: 0,
        vessel: '',
        voyageFlight: '',
        paymentTermMBL: '',
        freightTerm: '',
        seaEQ: [],
        container: []
      },
      jobField: [OCR_FIELD_CARRIER.code, OCR_FIELD_VESSEL.code, OCR_FIELD_VOYAGE.code, OCR_FIELD_ETD.code, OCR_FIELD_PAYMENT_TERM.code],
      initDoc: {
        billNo: '',
        mblNo: '',
        hblNo: '',
        orderType: '',
        blNumber: '',
        shipper: '',
        consignee: '',
        notify: '',
        paymentData: '',
        paymentPlaceBL: '',
        signPlaceBL: '',
        signDateBL: null,
        hsCode: '',
        dispatchingPlace: '',
        loadingPort: '',
        dischargingPort: '',
        destinationPort: '',
        quantity: 0,
        packing: '',
        insideQuantity: 0,
        insidePacking: '',
        weight: 0,
        cubage: 0,
        mark: '',
        cargoEnglishName: '',
        remarks: '',

        carrierId: 0,
        vessel: '',
        voyageFlight: '',
        paymentTermMBL: '',
        freightTerm: '',
        seaEQ: [],
        container: []
      },
      paymentTermMBL: null,
      branchOfficeCheck: false,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      OCR_FIELD_MAP,
      otherField: null,
      ocrRecognitionFields: [], // ocr识别字段
      ocrOtherFields: [], // 额外录单字段
      currentOcrRecognitionFields: [], // 当前 ocr识别字段
      currentOcrOtherFields: [], // 当前 额外录单字段
      fieldValidDialog: {
        visible: false,
        fieldValidResults: [] // 字段校验结果
      },
      fieldDefineMap: {}, // 字段定义
      firstEntry: true, // 首次进入时，字段、value框的颜色为默认值
      showBookRecognitionResults: true, // 展示托书识别结果
      vesselList: [], // 船名下拉列表
      showChooseShippingSchedulesBtn: false, // 显示【选择船期】 按钮
      jobData: {},
      jobContainer: [],
      seaEQ: [],
      seaCargoDoc: [],
      jobViewInfoMap: new Map()
    }
  },
  computed: {
    TYPE_NAMES() {
      return TYPE_NAMES
    },
    readOnly() {
      return this.details && this.details.status === 3
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    config() {
      return this.context.config
    }
  },
  watch: {
    details(val, oldVal) {
      if (val.resultJson !== oldVal.resultJson) {
        this.init()
      }
    },
    showAll(val, oldVal) {
      if (val !== oldVal) {
        this.showCurrentOcrRecognitionFields()
      }
    },
    index(val, oldVal) {
      if (val !== oldVal) {
        this.resultJson = this.resultArray[val].text.data
        this.doc = this.resultJson.docJson
        this.form = this.doc
        this.paymentTermMBL = this.doc.paymentTermMBL
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.pm.init()
    await cache.load(cacheName.CONFIG, cacheName.OFFICE)
    this.branchOfficeCheck = Number(cache.config.get('departmentSalesOfficeCheck')) === 1
    this.salesOfficeCheck = Number(cache.config.get('SalesOfficeCheck')) === 1
    loadSpecificBasicInfo('Vessel').then(res => {
      this.vesselList = res.data
    }).catch(() => {
    })
    await this.init()
  },
  methods: {
    handleFocus(val) {
      this.$emit('fieldFocus', val)
    },
    async init() {
      // 加载映射数据
      await this.initOcrSet()
      // 加载业务中的数据
      await this.initBaseData()
      // 加载在线对单配置
      await this.initOnlineOcr()
      // 【已录单】 字段展示历史的
      if (this.details.status === UPLOAD_STATUS_COMPLETE_ORDER.code && this.resultArray[0].ocrRecognitionFields && this.resultArray[0].ocrRecognitionFields.length > 0) {
        this.currentOcrRecognitionFields = this.resultArray[0].ocrRecognitionFields
        this.currentOcrOtherFields = this.resultArray[0].ocrOtherFields
      } else {
        this.currentOcrRecognitionFields = this.ocrRecognitionFields
        this.currentOcrOtherFields = this.ocrOtherFields
      }
      this.initOther()
      for (let i = 0; i < this.resultArray.length; ++i) {
        const result = this.resultArray[i]
        const resultJson = result.text.data
        // 第一次未保存时 取值逻辑，加载业务中信息
        if (!resultJson.docJson) {
          resultJson.docJson = deepClone(this.initDoc)
          resultJson.docJson.index = i
          this.setDocData(resultJson)
          this.setSeaEq(resultJson)
          this.setContainer(resultJson.docJson, resultJson, false)
          this.form = resultJson.docJson
          // 初始化时，备份jobJson，用于统计准确率（业务保存成功，异步进行统计）
          resultJson.originDocJson = deepClone(resultJson.docJson)
        } else {
          // 已经保存过后，除箱子信息 都取值上次保存过的值
          this.setSeaEq(resultJson)
          this.setContainer(resultJson.docJson, resultJson, true)
          resultJson.docJson.index = i
          this.form = resultJson.docJson
        }
      }
      setTimeout(() => {
        this.resultJson = this.resultArray[this.index].text.data
        this.doc = this.resultJson.docJson
        this.paymentTermMBL = this.doc.paymentTermMBL
        this.form = this.doc
        this.firstEntry = false
      }, 100)
    },
    // 根据【取值规则】组装finalResultJson
    getFinalResultJson(resultJson) {
      const finalResultJson = {}
      if (resultJson) {
        for (const fieldDetail of this.otherField.ocrOtherFieldDetails) {
          finalResultJson[fieldDetail.code] = resultJson[fieldDetail.code]
        }
      }
      return finalResultJson
    },
    // 字段校验
    async fieldValid() {
      if (this.otherField.ocrOtherFieldDetails && this.otherField.ocrOtherFieldDetails.length > 0) {
        const fieldValidResultsMap = new Map()
        // 必填项 校验 提单目前没有必填项 ，校验先去掉
        // const requiredFieldDetails = this.otherField.ocrOtherFieldDetails.filter(item => !!item.ifRequired && !!item.ifCheck)
        // if (requiredFieldDetails && requiredFieldDetails.length > 0) {
        //   for (let i = 0; i < this.resultArray.length; ++i) {
        //     const result = this.resultArray[i]
        //     const fieldValidResultByBook = {
        //       index: i,
        //       data: []
        //     }
        //     const doc = result.text.data.docJson
        //     for (const fieldDetail of requiredFieldDetails) {
        //       // 保存业务必填校验
        //       if (fieldDetail.ifRequired.split(',').length > 1 || fieldDetail.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code) {
        //         if (!doc[fieldDetail.code] || (Array.isArray(doc[fieldDetail.code]) && doc[fieldDetail.code].length === 0)) {
        //           fieldValidResultByBook.data.push({
        //             fieldName: OCR_FIELD_MAP.get(fieldDetail.code),
        //             exceptionReason: this.$t('queryJob.CannotBeEmpty')
        //           })
        //         }
        //       }
        //     }
        //     if (fieldValidResultByBook.data.length > 0) {
        //       fieldValidResultsMap.set(i, fieldValidResultByBook)
        //     }
        //   }
        // }

        for (let i = 0; i < this.resultArray.length; ++i) {
          const result = this.resultArray[i]
          const fieldValidResultByBook = {
            index: i,
            data: []
          }
          const doc = result.text.data.docJson
          let allNum = 0
          let checkNum = 0
          let hasError = false
          for (const seaEq of doc.seaEQ) {
            const key = seaEq.eqSize + seaEq.eqType
            let needNum = 0
            for (const container of doc.container) {
              // 识别出来的箱子也有临时uuid ，没有uuid的视为被覆盖箱子
              if (container.checked && container.uuid && container.eqSizeStr === key) {
                needNum++
              }
            }
            if (seaEq.eqQuantity !== needNum) {
              fieldValidResultByBook.data.push({
                fieldName: this.$t('CargoMsg.Cargo_ContainerInfo'),
                exceptionReason: this.$t('CargoMsg.Cargo_UpdateCheck1')
              })
              hasError = true
              break
            }
            // 汇总下一共需要多少箱子
            allNum += Number(seaEq.eqQuantity)
          }
          // 汇总下一共有多少箱子被勾选了
          if (!hasError) {
            for (const container of doc.container) {
              // 识别出来的箱子也有临时uuid ，没有uuid的视为被覆盖箱子
              if (container.checked && container.uuid) {
                checkNum++
              }
            }
            // 两者不一致 也是箱子对不上
            if (allNum !== checkNum) {
              fieldValidResultByBook.data.push({
                fieldName: this.$t('CargoMsg.Cargo_ContainerInfo'),
                exceptionReason: this.$t('CargoMsg.Cargo_UpdateCheck1')
              })
            }
          }
          if (fieldValidResultByBook.data.length > 0) {
            fieldValidResultsMap.set(i, fieldValidResultByBook)
          }
        }
        if (fieldValidResultsMap.size > 0) {
          this.fieldValidDialog.fieldValidResults = Array.from(fieldValidResultsMap.values()).sort((a, b) => a.index - b.index)
          this.fieldValidDialog.visible = true
          return false
        }
      }
      return true
    },
    changeValue(doc, targetField, replaceArr) {
      let result = 0
      if (!StrUtils.isEmpty(doc[targetField])) {
        result = doc[targetField]
        if (typeof result === 'string') {
          result = result.trim()
          for (const element of replaceArr) {
            result = result.replace(element, '')
          }
        }
      }
      return result
    },
    doSetEq(value) {
      const seaEq = []
      if (value) {
        const dataArray = value.split(',')
        for (const data of dataArray) {
          const cData = data.split(/[:]/g)
          const eqData = {}
          eqData.eqQuantity = Number(cData[1] || 1)
          if (cData[0].includes('\'')) {
            const sizeTypeData = cData[0].split(/[']/g)
            eqData.eqSizeOrg = sizeTypeData[0]
            eqData.eqTypeOrg = sizeTypeData[1]
          } else {
            const match = cData[0].match(/^(\d+)([A-Za-z]+)/)
            if (match) {
              eqData.eqSizeOrg = match[1]
              eqData.eqTypeOrg = match[2] && match[2].toUpperCase() === CONVERSION_HC.conversionValue ? CONVERSION_HC.originalValue : match[2]
            }
          }
          const eqSize = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.local_cache_EQSize, 'code', eqData.eqSizeOrg, 'code')
          const eqType = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_EQType, 'code', eqData.eqTypeOrg, 'code')
          if (eqSize) {
            eqData.eqSize = eqSize
          }
          if (eqType) {
            eqData.eqType = eqType
          }
          seaEq.push(eqData)
        }
      }
      return seaEq
    },
    setDocData(resultJson) {
      // 提单字段
      const seaDoc = this.seaCargoDoc[0]
      if (seaDoc) {
        const finalResultJson = this.getFinalResultJson(seaDoc)
        // 业务字段
        for (const f of this.jobField) {
          finalResultJson[f] = this.jobData[f]
        }
        // 提单号
        if (this.source === INTELLIGENT_DOCUMENT_SOURCE_5.code) {
          finalResultJson[OCR_FIELD_BILL_NO.code] = this.jobData.mblNo
        } else if (this.source === INTELLIGENT_DOCUMENT_SOURCE_7.code || this.source === INTELLIGENT_DOCUMENT_SOURCE_16.code) {
          finalResultJson[OCR_FIELD_BILL_NO.code] = seaDoc.hblNbr2
        }
        // 运费条款
        if (seaDoc.docType === CargoDocConsts.MBL) {
          finalResultJson[OCR_FIELD_PAYMENT_TERM.code] = this.jobData.paymentTermMBL
        } else if (seaDoc.docType === CargoDocConsts.HBL) {
          finalResultJson[OCR_FIELD_PAYMENT_TERM.code] = this.jobData.paymentTermHBL
        } else {
          finalResultJson[OCR_FIELD_PAYMENT_TERM.code] = seaDoc.paymentTerm
        }
        // 运输条款
        if (seaDoc.docType === CargoDocConsts.MBL || seaDoc.docType === CargoDocConsts.MBL2) {
          finalResultJson[OCR_FIELD_FREIGHT_TERM.code] = this.jobData.freightTerm
        } else if (seaDoc.docType === CargoDocConsts.HBL) {
          finalResultJson[OCR_FIELD_FREIGHT_TERM.code] = this.jobData.freightTermHBL
        } else {
          finalResultJson[OCR_FIELD_FREIGHT_TERM.code] = seaDoc.freightTermHBL
        }
        // 提单形式
        finalResultJson[OCR_FIELD_ORDER_TYPE.code] = seaDoc.releaseType
        // 收发通
        finalResultJson[OCR_FIELD_SHIPPER.code] = this.concatenateSft(OCR_FIELD_SHIPPER.code, seaDoc)
        finalResultJson[OCR_FIELD_CONSIGNEE.code] = this.concatenateSft(OCR_FIELD_CONSIGNEE.code, seaDoc)
        finalResultJson[OCR_FIELD_NOTIFY.code] = this.concatenateSft(OCR_FIELD_NOTIFY.code, seaDoc)
        finalResultJson['paymentData'] = this.concatenateSft('payment', seaDoc)
        // 将finalResultJson赋值给jobJson
        Object.assign(resultJson.docJson, finalResultJson)
      }
    },
    concatenateSft(type, seaDoc) {
      let value = ''
      for (let j = 0; j < 7; ++j) {
        if (value) {
          value += '\n'
        }
        value += seaDoc[type + 'Line' + `${j + 1}`]
      }
      return value.trimEnd()
    },
    setSeaEq(resultJson) {
      resultJson.docJson.seaEQ = []
      for (const seaEq of this.seaEQ) {
        const data = {}
        data.eqQuantity = seaEq.eqQuantity
        data.eqSize = seaEq.eqSize
        data.eqType = seaEq.eqType
        resultJson.docJson.seaEQ.push(data)
      }
    },
    setContainer(doc, resultJson, isSaveData) {
      // 保存过的提单 解析的箱子用上次保存的，业务中的还是实时取值
      // 初始化 解析的containers
      let containers = []
      if (isSaveData) {
        for (const data of doc.container) {
          if (data.chargeSource) {
            containers.push({
              uuid: 'addResultJson__' + getUuid(),
              no: 999,
              checked: true,
              showCheck: 1,
              chargeSource: true,
              containerNo: data.containerNo,
              eqSizeStr: data.eqSizeStr,
              eqType: '',
              sealNo: data.sealNo,
              quantity: data.quantity || 0,
              packing: data.packing,
              weight: data.weight || 0,
              cubage: data.cubage || 0
            })
          }
        }
      } else {
        if (resultJson.container) {
          containers = resultJson.container.map((c) => ({
            uuid: 'addResultJson__' + getUuid(),
            no: 999,
            checked: true,
            showCheck: 1,
            chargeSource: true,
            containerNo: c.container_containerNo,
            eqSizeStr: c.container_eqSize,
            eqType: '',
            sealNo: c.container_sealNo,
            quantity: c.container_quantity || 0,
            packing: c.container_packing,
            weight: c.container_weight || 0,
            cubage: c.container_cubage || 0
          }))
        }
      }
      // 调用 calculateContainer 方法处理容器
      doc.container = this.calculateContainer(containers, this.jobContainer || [])
      // 对结果进行排序
      this.sortedList(doc)
    },
    calculateContainer(containers, jobContainer) {
      const resultList = []
      const doneList = []
      // 遍历 jobContainer，处理匹配和未匹配的容器
      for (let i = 0; i < jobContainer.length; i++) {
        // 初始化系统箱子信息
        const j = jobContainer[i]
        j.eqSizeStr = j.eqSize + j.eqType
        j.showCheck = 1
        j.uuid = j.uuidOrg
        j.no = 500
        j.checked = true
        j.chargeSource = false
        // 查找匹配的容器
        const matchedContainer = containers.find(
          (d) => j.containerNo === d.containerNo && j.eqSizeStr === d.eqSizeStr && !doneList.includes(d.uuid)
        )
        if (matchedContainer) {
          const { uuid } = j
          matchedContainer.uuid = uuid
          // 如果找到匹配的容器，更新 showCheck 状态
          matchedContainer.showCheck = 0
          matchedContainer.no = i + 0.5
          matchedContainer.uuid = uuid // 把uuid给到识别数据，后端使用识别数据覆盖
          doneList.push(matchedContainer.uuid)
          j.showCheck = 2
          j.no = i
          j.uuid = ''
          resultList.push(j, matchedContainer)
        } else {
          // 如果没有匹配的容器，直接添加到 container
          resultList.push(j)
        }
      }
      // 添加未匹配的容器到 container
      resultList.push(...containers.filter((d) => !doneList.includes(d.uuid)))
      return resultList
    },
    sortedList(doc) {
      doc.container = [...doc.container].sort((a, b) => {
        // 排序逻辑
        const valueA = String(a.no)
        const valueB = String(b.no)
        return valueA.localeCompare(valueB)
      })
    },
    containerNoChargeHandler() {
      // 分离系统数据和托书数据
      // 系统数据
      const list1 = this.doc.container.filter((data) => !data.chargeSource)
      // 识别数据
      const list2 = this.doc.container.filter((data) => data.chargeSource)

      // 初始化 解析的containers
      list2.forEach((data) => {
        data.no = 999
        data.showCheck = 1
        data.uuid = 'addResultJson__' + getUuid()
      })
      // 合并并排序
      this.doc.container = this.calculateContainer(list2, list1)
      this.sortedList(this.doc)
    },
    initOther() {
      getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
        for (const item of data) {
          if (item.orderType === BlModeType.HBL.code) {
            const blMode = this.blModeList.find(p => p.uuid === item.uuid)
            if (!blMode) {
              this.blModeList.push(item)
            }
          }
        }
      })
    },
    async initBaseData() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyStr: this.details.jobUuid,
        anyStr1: this.details.docUuid
      }
      await queryJobDataFunc(params).then(res => {
        this.jobData = res.data.job
        this.jobContainer = res.data.containers
        if (this.jobContainer) {
          this.jobContainer.forEach((data) => {
            data.uuidOrg = data.uuid
          })
        }
        this.seaEQ = res.data.seaEQ
        this.seaCargoDoc = res.data.seaCargoDoc
      })
    },
    // 在线对单配置
    async initOnlineOcr() {
      const params = {
        ocrCheck: true,
        branchId: this.$store.getters.currentOfficeId,
        docType: this.source === INTELLIGENT_DOCUMENT_SOURCE_5.code ? MBL.code : HBL.code
      }
      await getSingleOnlineSettingList(params).then(results => {
        const onlineRowData = results.data
        for (const data of onlineRowData) {
          this.onlineMap[data.ocrCode] = data
        }
      })
    },
    // 获取OCR映射
    async initOcrSet() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyInteger: SENDING_2.code, // 应用场景 0海运出口托书识别 2 海出提单
        anyBool: true // 应用场景 判断是否应用总部
      }
      await getOcrList(params).then(res => {
        const ocrSet = res.data
        if (ocrSet) {
          // 额外录单字段
          this.toOtherField(ocrSet)
        }
      })
    },
    // 额外录单字段
    toOtherField(ocrSet) {
      this.otherField = ocrSet.finalField

      this.fieldDefineMap = ocrSet.fieldDefineMap
      if (this.otherField.ocrOtherFieldDetails) {
        // ocr识别字段
        this.ocrRecognitionFields = this.otherField.ocrOtherFieldDetails.filter(item => {
          const fieldD = this.fieldDefineMap[item.code]
          if (fieldD) {
            return !fieldD.ifExtraField
          } else {
            return false
          }
        })
        // 额外录单字段
        this.ocrOtherFields = []
      }
    },
    doMapperShipName(value) {
      if (!StrUtils.isEmpty(value)) {
        // 用解析值 匹配 代码
        let carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', value, 'cmpIdx')
        carrierId = this.checkOfficeId(carrierId)
        if (!carrierId) {
          // 用解析值 匹配 英文名
          carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', value, 'cmpIdx')
          carrierId = this.checkOfficeId(carrierId)
          if (!carrierId || Number(carrierId) <= 0) {
            // 用解析值 匹配 中文名
            carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', value, 'cmpIdx')
            carrierId = this.checkOfficeId(carrierId)
            if (!carrierId || Number(carrierId) <= 0) {
              // 用解析值 匹配 简称
              carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'shortName', value, 'cmpIdx')
              carrierId = this.checkOfficeId(carrierId)
              if (!carrierId || Number(carrierId) <= 0) {
                const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CARRIER.code + '_' + this.useCase + '_' + value
                const newMapperVal = this.carrier.get(mapperKey)
                if (newMapperVal) {
                  // 用映射值 匹配 代码
                  carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                  carrierId = this.checkOfficeId(carrierId)
                  if (!carrierId || Number(carrierId) <= 0) {
                    // 用映射值 匹配 英文名
                    carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                    carrierId = this.checkOfficeId(carrierId)
                    if (!carrierId || Number(carrierId) <= 0) {
                      // 用映射值 匹配 中文名
                      carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                      carrierId = this.checkOfficeId(carrierId)
                      if (!carrierId || Number(carrierId) <= 0) {
                        // 用映射值 匹配 简称
                        carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'shortName', newMapperVal, 'cmpIdx')
                        carrierId = this.checkOfficeId(carrierId)
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return carrierId || 0
      }
      return 0
    },
    checkOfficeId(carrierId) {
      if (carrierId && carrierId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', carrierId)
        if (company && (!company.seaCmp || !company.active || (company.branchId !== 1 && company.branchId !== this.$store.getters.currentOfficeId &&
          (!company.multipleBranchId || (company.multipleBranchId && !company.multipleBranchId.split(',').includes(String(this.$store.getters.currentOfficeId))))))) {
          carrierId = 0
        }
      }
      return carrierId
    },
    // 运输条款
    doMapperFreightTerm(value) {
      if (!StrUtils.isEmpty(value)) {
        // 用解析值 匹配 代码
        let freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'code', value, 'code')
        if (!freightTerm) {
          // 用解析值 匹配 英文名
          freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'name', value, 'code')
          if (!freightTerm) {
            // 用解析值 匹配 中文名
            freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'localName', value, 'code')
            if (!freightTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code + '_' + this.useCase + '_' + value
              const newMapperVal = this.shippingTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'code', newMapperVal, 'code')
                if (!freightTerm) {
                  // 用映射值 匹配 英文名
                  freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'name', newMapperVal, 'code')
                  if (!freightTerm) {
                    // 用映射值 匹配 中文名
                    freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        return freightTerm || ''
      }
      return ''
    },
    // 运费条款
    doMapperPaymentTerm(paymentTermMBL) {
      if (!StrUtils.isEmpty(paymentTermMBL)) {
        // 用解析值 匹配 代码
        let paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'code', paymentTermMBL, 'code')
        if (!paymenTerm) {
          // 用解析值 匹配 英文名
          paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'name', paymentTermMBL, 'code')
          if (!paymenTerm) {
            // 用解析值 匹配 中文名
            paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'localName', paymentTermMBL, 'code')
            if (!paymenTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code + '_' + this.useCase + '_' + paymentTermMBL
              const newMapperVal = this.paymentTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'code', newMapperVal, 'code')
                if (!paymenTerm) {
                  // 用映射值 匹配 英文名
                  paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'name', newMapperVal, 'code')
                  if (!paymenTerm) {
                    // 用映射值 匹配 中文名
                    paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        return paymenTerm || ''
      }
      return ''
    },
    // 贸易条款
    mapperIncoTerm(doc, resultJson) {
      if (!StrUtils.isEmpty(resultJson.incoTerm)) {
        // 用解析值 匹配 代码
        let incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'code', resultJson.incoTerm, 'code')
        if (!incoTerm) {
          // 用解析值 匹配 英文名
          incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'name', resultJson.incoTerm, 'code')
          if (!incoTerm) {
            // 用解析值 匹配 中文名
            incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'localName', resultJson.incoTerm, 'code')
            if (!incoTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code + '_' + this.useCase + '_' + resultJson.incoTerm
              const newMapperVal = this.incoTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'code', newMapperVal, 'code')
                if (!incoTerm) {
                  // 用映射值 匹配 英文名
                  incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'name', newMapperVal, 'code')
                  if (!incoTerm) {
                    // 用映射值 匹配 中文名
                    incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        doc.incoTerm = incoTerm || ''
      }
    },
    doMapperPacking(packingVal, realPacking) {
      let packingCode = ''
      if (!StrUtils.isEmpty(realPacking)) {
        // 用解析值 匹配 代码
        packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'code', realPacking, 'code')
        if (!packingCode) {
          // 用解析值 匹配 英文名
          packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'name', realPacking, 'code')
          if (!packingCode) {
            // 用解析值 匹配 中文名
            packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'chineseName', realPacking, 'code')
            if (!packingCode) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PACKING.code + '_' + this.useCase + '_' + realPacking
              const newMapperVal = this.packing.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'code', newMapperVal, 'code')
                if (!packingCode) {
                  // 用映射值 匹配 英文名
                  packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'name', newMapperVal, 'code')
                  if (!packingCode) {
                    // 用映射值 匹配 中文名
                    packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'chineseName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        if (!packingVal) { // 多单模式时 packingVal 有值
          return packingCode || ''
        }
      }
      return ''
    },
    // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
    doMapperOrderType(value) {
      if (!StrUtils.isEmpty(value)) {
        let releaseType = null
        const orderType = value
        if (orderType === 'ORIGINAL') {
          releaseType = 1
        } else if (orderType === 'SURRENDERED') {
          releaseType = 2
        } else if (orderType === 'SEA WAYBILL') {
          releaseType = 3
        } else {
          releaseType = ColumnUtils.getBlModeSerialNumberByName(orderType)
        }
        if (releaseType) {
          const mapperKey = SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code + '_' + this.useCase + '_' + value
          const newMapperVal = this.orderType.get(mapperKey)
          if (newMapperVal) {
            // 用映射值 匹配 中英文名
            releaseType = ColumnUtils.getBlModeSerialNumberByName(newMapperVal)
          }
        }
        return releaseType
      }
      return null
    },
    signDateBLChange(value) {
      this.doc.signDateBL = value
    },
    // 保存时获取数据
    getSubmitData() {
      const result = this.resultJson
      result.docJson = this.doc
      return result
    },
    changeSizeCallBack(item, p) {
      item.eqSizeOrg = item.eqSize = p.value
      // item.showEQ = 'X' + item.eqSizeOrg + '' + item.eqTypeOrg
    },
    changeTypeCallBack(item, p) {
      item.eqTypeOrg = item.eqType = p.value
      // item.showEQ = 'X' + item.eqSizeOrg + '' + item.eqTypeOrg
    },
    itemAssignClick(item) {
      const code = item.code
      if (this.otherCheckField.includes(code)) {
        if (code === SystemConstants.OCR_FIELD_ORDER_TYPE.code) {
          this.doc[code] = this.doMapperOrderType(this.resultJson[code])
        }
        if (code === SystemConstants.OCR_FIELD_CARRIER.code) {
          this.doc[code] = this.doMapperShipName(this.resultJson[code])
        }
        if (code === SystemConstants.OCR_FIELD_PAYMENT_TERM.code) {
          this.doc[code] = this.doMapperPaymentTerm(this.resultJson[code])
        }
        if (code === SystemConstants.OCR_FIELD_FREIGHT_TERM.code) {
          this.doc[code] = this.doMapperFreightTerm(this.resultJson[code])
        }
        if (code === SystemConstants.OCR_FIELD_PACKING.code) {
          this.doc[code] = this.doMapperPacking('', this.resultJson[code])
        }
        if ([SystemConstants.OCR_FIELD_TD_WEIGHT.code, SystemConstants.OCR_FIELD_TD_CUBAGE.code].includes(code)) {
          this.doc[code] = Number(this.resultJson[code])
        }
      } else {
        this.doc[code] = this.resultJson[code]
      }
      item.itemAssignUpdate = true
    },
    // 提单没有 save_job 但暂时不删
    getFieldColor(item) {
      if (!this.firstEntry && item.ifCheck && item.ifRequired) {
        if (item.ifRequired.split(',').length > 1 || item.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code) {
          return '#1398f1'
        }
      }
      return '#8c8d8e'
    },
    getValueBorderColor(item) {
      if (this.details.status !== UPLOAD_STATUS_PARSE_DONE.code) {
        return
      }
      let newValue = this.doc[item.code]
      let oldValue = this.resultJson[item.code]
      if (oldValue === undefined) {
        oldValue = ''
      }
      if (newValue === undefined) {
        newValue = ''
      }
      item.redColor = false
      item.showField = false
      if (item.itemAssignUpdate) {
        item.showField = true
        return
      }
      if (this.otherCheckField.includes(item.code)) {
        const color = this.otherCheckFieldHandler(item.code, newValue, oldValue)
        if (this.colorStyle === color) {
          item.redColor = true
          item.showField = true
        }
      } else if (String(newValue) !== String(oldValue)) {
        item.redColor = true
        item.showField = true
      }
      return '#111111FF'
    },
    showCurrentOcrRecognitionFields() {
      for (const item of this.currentOcrRecognitionFields) {
        item.itemAssignUpdate = false
      }
    },
    // 新增 箱型箱量
    addSeaEQ() {
      this.doc.seaEQ.push({})
    },
    // 删除 箱型箱量
    deleteSeaEQ(index) {
      this.doc.seaEQ.splice(index, 1)
    },
    // 船名变更调整
    async onVesselSelectionChange(data) {
      this.doc.vessel = data.value
      // 无值不清空
      if (data.callSign) {
        this.doc.vesselCode = data.callSign
      }
    },
    clear(item) {
      this.resultJson[item.code + '_notShowPlaceholder'] = true
      this.$forceUpdate()
    },
    showFieldItem(item, code) {
      return item.code === code && (this.showAll || (item.showField && !this.showAll))
    },
    otherCheckFieldHandler(code, newValue, oldValue) {
      try {
        if (code === SystemConstants.OCR_FIELD_ORDER_TYPE.code) {
          const orderType = this.blModeList.filter(p => p.serialNumber === newValue)
          if (orderType && orderType.length > 0) {
            if (oldValue !== orderType[0].name) {
              return this.colorStyle
            }
          } else {
            return this.colorStyle
          }
        }
        if (code === SystemConstants.OCR_FIELD_CARRIER.code) {
          const carrier = this.doMapperShipName(oldValue)
          if (carrier !== newValue) {
            return this.colorStyle
          }
        }
        if (code === SystemConstants.OCR_FIELD_PAYMENT_TERM.code) {
          const paymentTermMBL = this.doMapperPaymentTerm(oldValue)
          if (paymentTermMBL !== newValue) {
            return this.colorStyle
          }
        }
        if (code === SystemConstants.OCR_FIELD_FREIGHT_TERM.code) {
          const freightTerm = this.doMapperFreightTerm(oldValue)
          if (freightTerm !== newValue) {
            return this.colorStyle
          }
        }
        if (code === SystemConstants.OCR_FIELD_PACKING.code) {
          const packingCode = this.doMapperPacking('', oldValue)
          if (packingCode !== newValue) {
            return this.colorStyle
          }
        }
        if (code === SystemConstants.OCR_FIELD_CONTAINER_INFOS.code) {
          const orgEq = this.doSetEq(oldValue)
          if (orgEq && newValue) {
            if (!this.areArraysEqual(orgEq, newValue)) {
              return this.colorStyle
            }
          }
        }
        if ([SystemConstants.OCR_FIELD_TD_WEIGHT.code, SystemConstants.OCR_FIELD_TD_CUBAGE.code].includes(code)) {
          if (Number(newValue) !== Number(oldValue)) {
            return this.colorStyle
          }
        }
      } catch (e) {
        console.log('otherCheckFieldHandler' + e)
      }
      return '#111111FF'
    },
    areArraysEqual(arr1, arr2) {
      // 对两个数组进行排序
      let sortedArr1 = ''
      let sortedArr2 = ''
      for (const data of arr1) {
        if (sortedArr1) {
          sortedArr1 += ';'
        }
        sortedArr1 += 'eqSize:' + data.eqSize + 'eqType:' + data.eqType + 'eqQuantity:' + data.eqQuantity
      }
      // 排除掉空数据
      for (const data of arr2) {
        if (data.eqSize || data.eqType || data.eqQuantity) {
          if (sortedArr2) {
            sortedArr2 += ';'
          }
          sortedArr2 += 'eqSize:' + data.eqSize + 'eqType:' + data.eqType + 'eqQuantity:' + data.eqQuantity
        }
      }
      return sortedArr1 === sortedArr2
    },
    fieldEditCheck(code) {
      if (!this.onlineMap) {
        return false
      }
      if (['container_containerNo', 'container_sealNo'].includes(code)) {
        const seaDoc = this.seaCargoDoc[0]
        if (seaDoc && [CargoDocConsts.MBL2, CargoDocConsts.HBL2, CargoDocConsts.HAWB2].includes(seaDoc.docType)) {
          return true
        }
      }
      const containerLoadType = FCL.code
      const onlineItem = this.onlineMap[code]
      if (onlineItem) {
        if (containerLoadType === FCL.code) {
          return !onlineItem.fclEdit
        } else if (containerLoadType === LCL.code) {
          return !onlineItem.lclEdit
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.result-form-se {
  display: flex;
  .row {
    display: flex;
    align-items: stretch
  }
  .item1 {
    min-width: 100px;
    border: 1px solid white;
    background-color: #e9edf1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
  }
  .item2 {
    width: 100%;
    min-width: 100px;
    border: 1px solid white;
    background-color: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    pointer-events: none;
  }
  .itemAssign {
    position: relative;
  }
  .itemAssign2 {
    height: 25px;
    position: absolute;
    top: 50%;
    left: -30px; /* 向右移动 */
    transform: translateY(-50%); /* 垂直居中 */
    width: 30px;
    line-height: 20px; /* 使文本垂直居中 */
    background-color: #fff; /* 背景颜色 */
    border: 1px solid #ccc; /* 边框 */
    border-radius: 5px; /* 圆角 */
    padding: 0 5px; /* 内边距 */
    color: #333; /* 文本颜色 */
    font-size: 14px; /* 文本大小 */
    z-index: 1; /* 确保伪元素在最上层 */
  }
  .item3 {
    width: 100%;
    border: 1px solid #cee0c8;
    background-color: #cee0c8;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    /deep/ input.el-input__inner {
      background-color: #cee0c8 !important;
      text-align: left;
    }
    .item3-1 /deep/ input.el-input__inner {
      background-color: white;
    }
    /deep/ .el-textarea__inner {
      background-color: #cee0c8 !important;
    }
  }
  .item4 {
    width: 100%;
    border: 1px solid white;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    /deep/ input.el-input__inner {
      background-color: white;
    }
    /deep/ .el-textarea__inner {
      background-color: white;
    }
  }
  .color-yellow {
    /deep/ textarea.el-textarea__inner {
      color: #e36402;
    }
  }
  .is-require {
    color: #4abff3;
  }
  .input-red::v-deep{
    .el-input__inner {
      color: red !important;
    }
  }
  .textarea-red {
    /deep/ .el-input__inner,
    /deep/ .el-textarea__inner,
    /deep/ .cargo-rich-textarea{
      color: red !important;
    }
  }
  .color-red {
    /deep/ input::placeholder{
      color: red !important;
    }
  }
  .table {
    border-collapse: collapse; /* 合并边框 */
    width: 100%;
  }

  td {
    border: 1px solid #ccc;
    padding: 2px;
  }
  .gray-row {
    background-color: #f2f2f2; /* 灰色背景 */
  }
  .centered-cell {
    text-align: center; /* 文字居中对齐 */
  }
}
</style>
